<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@font-face {
  font-family: 'PingFang-SC';
  src: url('@/assets/font/PingFang-SC.TTF');
}
#app {
  font-family: PingFang-SC, Microsoft YaHei;
  height: 100%;
  font-weight: 400;
}
</style>
